import React, { ReactNode, useEffect } from "react";
import {
  CopyToClipboard as _CopyToClipboard,
  Props,
} from "react-copy-to-clipboard";
import { useImmer } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { SxProps } from "@mui/system";

interface ClipboardCopyProps {
  copyText: string;
  codeFont?: boolean;
  direction?: "row" | "column";
  copyButtonText?: { copy: string; copied: string };
  copyTextSx?: SxProps;
  copyButton?: ReactNode;
  copyTextTitle?: ReactNode;
  showUrl?: boolean;
}

const CopyToClipboard = _CopyToClipboard as unknown as (
  props: Props
) => ReactNode;

export const ClipboardCopy = ({
  copyText,
  codeFont,
  direction,
  copyButtonText,
  copyTextSx,
  copyButton,
  copyTextTitle,
  showUrl = true,
}: ClipboardCopyProps) => {
  const [isCopied, setIsCopied] = useImmer(false);

  useEffect(() => {
    setIsCopied(false);
  }, [copyText]);

  return (
    <Grid
      item
      container
      direction={direction || "row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      rowSpacing={2}
      sx={{ maxWidth: "100%" }}
      flexWrap={"nowrap"}
    >
      {(copyTextTitle || showUrl) && (
        <Grid item>
          {copyTextTitle && (
            <Grid item>
              <IgTypography igStyle={"semibold"}>
                <>{copyTextTitle}</>
              </IgTypography>
            </Grid>
          )}
          {showUrl && (
            <Grid item sx={{ overflowX: "scroll" }}>
              <IgTypography variant={"code"}>{copyText}</IgTypography>
            </Grid>
          )}
        </Grid>
      )}
      <Grid item>
        <CopyToClipboard
          text={copyText}
          onCopy={() => {
            setIsCopied((draft) => !draft);
          }}
        >
          {
            (copyButton ? (
              copyButton
            ) : (
              <IgButton
                igVariant={isCopied ? "success" : undefined}
                variant={"contained"}
              >
                {copyButtonText
                  ? isCopied
                    ? copyButtonText.copied
                    : copyButtonText.copy
                  : isCopied
                    ? "Copied"
                    : "Copy"}
              </IgButton>
            )) as any
          }
        </CopyToClipboard>
      </Grid>
    </Grid>
  );
};
